import { configure } from '../lib/configure.js';
import { toUrlSearchParams } from '../lib/to-url-search-params.js';
import HTTP from 'ipfs-utils/src/http.js';
export const createRm = configure(api => {
  async function rm(path, options = {}) {
    const res = await api.post('files/rm', {
      signal: options.signal,
      searchParams: toUrlSearchParams({
        arg: path,
        ...options
      }),
      headers: options.headers
    });
    const body = await res.text();
    if (body !== '') {
      const error = new HTTP.HTTPError(res);
      error.message = body;
      throw error;
    }
  }
  return rm;
});